const manageButton = (editor) => {
    editor.BlockManager.add(`manageButton`, {
        label: `Manage Button`,
        category: 'Buttons',
        content: '<div class="btn pointer bi bi-pencil-square manage-btn">Manage</div>',
        attributes: { class: 'fa fa-plus-square' }
    });
}

export default manageButton;